import _ from 'lodash'

export default ({ eventTypesData: { eventTypes }, name }) =>
  _.pick(_.find(eventTypes, { name }), 'id')
